export const validateMessagePrice = (
  price: string | number | undefined,
  min: number,
  max: number,
): boolean => {
  if (!price) {
    return true
  }

  const priceAsNum = Number(price)

  if (priceAsNum === 0) {
    return true
  }

  return !(isNaN(priceAsNum) || priceAsNum < min || priceAsNum > max)
}
